<template>
  <bridged-a
    role="listitem"
    class="tv-cell tv-cell-subtitle tv-cell-button"
    :href="'/' + wall.address"
    target="_blank"
    bridge-target="padlet"
    data-app-target="blank"
  >
    <div class="tv-cell-thumb" :style="{ background: backgroundStyle }" />
    <div class="tv-cell-text flex justify-between">
      <div>
        <h3>{{ title }}</h3>
        <div class="small-caption-type">
          <span>{{ wall.builder.display_name || wall.builder.displayName }}</span> •
          <relative-time :datetime="wall.updated_at || wall.updatedAt" dateformat="short" />
        </div>
      </div>

      <div v-if="wall.is_private" class="flex items-center">
        <base-icon name="lock" class="text-canary-500 m-0 mb-1" />
        <div class="flex flex-col -ml-2">
          <span class="text-dark-text-100">{{ __('Private') }}</span>
          <span class="text-body-extra-small text-dark-text-200">{{
            __('Only the owner and collaborators can access it.')
          }}</span>
        </div>
      </div>
    </div>
    <padlet-card-actions v-if="actions" class="accessory" type="list" :wall="wall" />
  </bridged-a>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { processedUrl } from '@padlet/vivaldi-client'
import RelativeTime from 'library/v4/components/relative-time'
import BridgedA from 'vuecomponents/bridged_a'
import PadletCardActions from 'vuecomponents/padlet_card_actions'
import BaseIcon from 'vuecomponents/base_icon.vue'
import { __ } from 'bits/intl'

export default {
  components: { RelativeTime, BridgedA, PadletCardActions, BaseIcon },
  props: ['wall', 'actions'],
  computed: {
    title: function () {
      return this.wall.title || __('Untitled padlet')
    },
    backgroundStyle: function () {
      const bg = this.wall.background
      const dominantColor = bg.dominant_color || bg.dominantColor || [33, 33, 33]
      const dominantColorAsRgb = `rgb(${dominantColor.join(',')})`
      const backgroundUrl = processedUrl(bg.url, {
        crop: 'thumb',
        width: 56,
        height: 56,
      })
      const backgroundImage = `url("${backgroundUrl}")`
      return [backgroundImage, dominantColorAsRgb, 'center/cover'].join(' ')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';

.tv-cell-thumb {
  width: 56px;
  height: 56px;
  box-sizing: border-box;
  border-radius: 8px;
  background-size: cover;
}
.accessory {
  @include directional-margin($margin-right: -16px, $margin-left: 0);
}
</style>
